import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import CardGridSection from '../ui-kit/CardGridSection/CardGridSection';

const SECTION_COLOR = '#F9F6EB';

const sectionProps = {
  background: SECTION_COLOR,
  title: 'Why Deliver With Us?',
  columnCount: 2,
  imageStyle: { borderRadius: '50%', width: '70%', margin: '0 auto' },
  cards: [
    {
      heading: 'Easy to get started',
      image: {
        url: '/driver/driving.png',
        alt: 'Picture over the shoulder of a person driving a car',
        height: 220,
        width: 220,
      },
      description:
        'No need for car inspections or vehicle restrictions. Just sign up, get approved, and start earning',
    },
    {
      heading: 'Set your own schedule',
      image: {
        url: '/driver/clock.png',
        alt: 'Picture of a clock',
        height: 220,
        width: 220,
      },
      description:
        'With no set hours or days, deliver as much or as little as you want on your own terms',
    },
    {
      heading: 'Get real time support',
      image: {
        url: '/driver/hands.png',
        alt: 'Picture of several hands near each other on a table',
        height: 220,
        width: 220,
      },
      description:
        'Our customer care team is always there to provide support to set you up for success',
    },
    {
      heading: 'Join the community',
      image: {
        url: '/driver/chowbus-delivery-driver.png',
        alt: 'Picture of a chowbus delivery driver handing a meal to a customer',
        height: 220,
        width: 220,
      },
      description: 'Get tips from others, attend Chowbus events, and be part of the Chowbus family',
    },
  ],
};

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: SECTION_COLOR,
    '& > section': {
      maxWidth: '70%',
      margin: '0 auto',
    },
    [theme.breakpoints.down('sm')]: {
      '& > section': {
        maxWidth: '90%',
      },
    },
  },
}));

const WhyDriveWithUs = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CardGridSection {...sectionProps} />
    </div>
  );
};

export default WhyDriveWithUs;
